// Chính sách quyền riêng tư — trang công khai (không cần đăng nhập), dùng làm Privacy Policy URL trên
// App Store Connect (Guideline 5.1.1(i)). Văn bản do pháp chế soạn: src/content/legal/privacy.md — sửa nội dung ở
// file đó (khớp nhãn App Privacy, docs/app-store-submission.md §5, và luồng xoá tài khoản).

import privacyMd from '@/content/legal/privacy.md?raw'
import { LegalDocumentPage } from '@/components/legal/LegalDocumentPage'
import { parseLegalDoc } from '@/lib/legalDoc'

const DOC = parseLegalDoc(privacyMd, { numberSections: false, idPrefix: 'p' })

export default function PrivacyPage() {
  return <LegalDocumentPage doc={DOC} back={{ to: '/login', label: 'Quay lại' }} related={{ to: '/terms', label: 'Điều khoản sử dụng' }} />
}
